<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>처방문의</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">처방 문답</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>문의 사항</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.inquiry_details}}</span>
                </td>
              </tr>
              <tr>
                <th>카테고리</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.prescribe_category_nm}}</span>
                </td>
              </tr>
              <tr>
                <th>주소증</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.chief_complaint}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">환자 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>나이</th>
                <td>
                  <span>{{formulaQnaInfo.age}}</span>
                </td>
                <th>성별</th>
                <td>
                  <span>{{formulaQnaInfo.gender_nm}}</span>
                </td>
              </tr>
              <tr>
                <th>키</th>
                <td>
                  <span>{{formulaQnaInfo.height}} cm</span>
                </td>
                <th>몸무게</th>
                <td>  
                  <span>{{formulaQnaInfo.weight}} kg</span>
                </td>
              </tr>
              <tr>
                <th>혈압</th>
                <td>
                  <span>{{formulaQnaInfo.blood_pressure}}</span>
                </td>
                <th>맥박수</th>
                <td>
                  <span>{{formulaQnaInfo.pulse_rate}} 회/분</span>
                </td>
              </tr>
              <tr>
                <th>사상체질</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.sasang_constitution}}</span>
                </td>
              </tr>
              <tr>
                <th>기왕력</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.past_medical_history}}</span>
                </td>
              </tr>
              <tr>
                <th>진맥</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.pulse_diagnosis}}</span>
                </td>
              </tr>
              <tr>
                <th>복진</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.abdominal_exam}}</span>
                </td>
              </tr>
              <tr>
                <th>대변</th>
                <td>
                  <span>{{formulaQnaInfo.bowel_condition}}</span>
                </td>
                <th>소변</th>
                <td>
                  <span>{{formulaQnaInfo.urinary_condition}}</span>
                </td>
              </tr>
              <tr>
                <th>한출</th>
                <td>
                  <span>{{formulaQnaInfo.sweating_pattern}}</span>
                </td>
                <th>심계</th>
                <td>
                  <span>{{formulaQnaInfo.palpitations}}</span>
                </td>
              </tr>
              <tr>
                <th>수면</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.sleep_condition}}</span>
                </td>
              </tr>
              <tr>
                <th>갈증</th>
                <td>
                  <span>{{formulaQnaInfo.thirst}}</span>
                </td>
                <th>물 선호</th>
                <td>
                  <span>{{formulaQnaInfo.water_preference}}</span>
                </td>
              </tr>
              <tr>
                <th>소화 상태</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.digestion_condition}}</span>
                </td>
              </tr>
              <tr>
                <th>식용</th>
                <td>
                  <span>{{formulaQnaInfo.appetite}}</span>
                </td>
                <th>붓기</th>
                <td>
                  <span>{{formulaQnaInfo.edema}}</span>
                </td>
              </tr>
              <tr>
                <th>한열</th>
                <td>
                  <span>{{formulaQnaInfo.cold_heat_sensation}}</span>
                </td>
                <th>두통</th>
                <td>
                  <span>{{formulaQnaInfo.headache}}</span>
                </td>
              </tr>
              <tr>
                <th>기타</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.etc}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">처방 문답</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>{{doctor_nm}}</th>
                <td colspan="3">
                  <div class="flex items-center gap8">
                    <textarea
                      name=""
                      id=""
                      class="form_control"
                      placeholder="입력해주세요"
                      v-model="commentInfo.comment_contents"
                    >
                    </textarea>
                    <button class="btn btn_md btn_brown" @click="fn_comment_save">답변 등록</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">베스트 댓글</h3>
          <table class="list no_view">
            <colgroup>
              <col width="200" />
              <col width="*" />
            </colgroup>
            <thead>
              <tr>
                <th>등록자</th>
                <th>답변</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="formulaQnaBestComment == null">
                  <td colspan="2"><span>선택된 답변이 없습니다.</span></td>
              </tr>
              <tr v-if="formulaQnaBestComment != null">
                    <td><span>{{formulaQnaBestComment.doctor_nm}}</span></td>
                    <td><span>{{formulaQnaBestComment.comment_contents}}</span></td>
              </tr>
              
            </tbody>
          </table>
          <!-- <Pagination /> -->
        </div>

        <div class="table_list">
          <h3 class="tb_title">댓글</h3>
          <table class="list no_view">
            <colgroup>
              <col width="200" />
              <col width="*" />
              <col v-if="formulaQnaInfo.reg_id == clinic_doctor_id && formulaQnaBestComment == null" width="80" />
            </colgroup>
            <thead>
              <tr>
                <th>등록자</th>
                <th>답변</th>
                <th v-if="formulaQnaInfo.reg_id == clinic_doctor_id && formulaQnaBestComment == null">선택</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="formulaQnaComment.length == 0">
                  <td colspan="2"><span>데이터가 없습니다.</span></td>
              </tr>
              <tr
                    v-for="(item, index) in formulaQnaComment"
                    :key="index"
                  >
                    <td><span>{{item.doctor_nm}}</span></td>
                    <td><span>{{item.comment_contents}}</span></td>
                    <td  v-if="formulaQnaInfo.reg_id == clinic_doctor_id && formulaQnaBestComment == null">
                      <button v-if="item.write_user_id != formulaQnaInfo.reg_id" class="btn btn_md btn_blue" @click="fn_comment_best(item.comment_seq)">답변 체택</button>
                    </td>
              </tr>
              
            </tbody>
          </table>
          <!-- <Pagination /> -->
        </div>

        <div class="bottom_box bn">
          <button class="btn btn_md btn_darkbrown" @click="$router.go(-1)">
            목록
          </button>
        </div>
      </article>
    </section>
    <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        v-on:update:showSetting="fn_showSet"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  components: {
    Pagination,
    AlertModal
  },
  mixins: [alertutill],
  data() {
    return {
      formula_inquiry_seq : '',
      clinic_doctor_id : '',
      doctor_nm : '',
      formulaQnaInfo : {},
      formulaQnaComment : [],
      formulaQnaBestComment : {},
      commentInfo : {
        formula_inquiry_seq : '',
        clinic_doctor_id : '',
        comment_contents : ''
      }
    };
  },
  created(){
    this.formula_inquiry_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.commentInfo.formula_inquiry_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.doctor_nm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
    this.commentInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){
    this.fn_search();
  },
  methods : {
    fn_search(){

        //환자seq 정보 셋팅
        let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;

        //상세조회
        axios
            .post("/api/user/board/getformulaQnaDetail", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.formulaQnaInfo = res.data.formulaQnaInfo;
                this.formulaQnaComment = res.data.formulaQnaComment;
                this.formulaQnaBestComment = res.data.bestComment;
            })
            .catch((err) => console.log(err));
            
    },
    fn_comment_search(){
      let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;

        //환자정보 상세조회
        axios
            .post("/api/user/board/getformulaQnaComment", param)
            .then((res) => {
                this.formulaQnaComment = res.data.formulaQnaComment;
                this.formulaQnaBestComment = res.data.bestComment;
            })
            .catch((err) => console.log(err));
    },
    fn_comment_save(){
      axios
        .post("/api/user/board/saveFormulaQnaComment", this.commentInfo)
        .then((res) => {

            let msg = "댓글이 저장되었습니다.";
            this.fn_open_alert(msg); 

            this.commentInfo.comment_contents = '';
            this.fn_comment_search();
        })
        .catch((err) => console.log(err));
    },
    fn_comment_best(seq){
      let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;
        param.comment_seq = seq;

        axios
        .post("/api/user/board/saveFormulaQnaBestComment", param)
        .then((res) => {

            let msg = "베스트 댓글이 선택되었습니다.";
            this.fn_open_alert(msg); 

            this.commentInfo.comment_contents = '';
            this.fn_comment_search();
        })
        .catch((err) => console.log(err));

    },
    fn_move_listPage(){
      this.$store.dispatch('detailSearchInfo/setSearchId', '');
      this.$router.push("/formulaQna");
    },
  }
};
</script>
